import React, { useState, useCallback, useEffect } from "react";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import DoneOutlineIcon from "@material-ui/icons/DoneOutline";
import VpnKeyIcon from "@material-ui/icons/VpnKey";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import SearchIcon from "@material-ui/icons/Search";
import LockIcon from "@material-ui/icons/Lock";

import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import CardHeader from "@material-ui/core/CardHeader";

import {
  Button,
  Grid,
  TextField,
  Divider,
  Box,
  Typography,
} from "@material-ui/core";

import { userList, userActivation } from "../../../adminModel/users";
import { useAlert } from "react-alert";
import { Link } from "react-router-dom";
import Api from "../../../Api";
import api from "../../../axios";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },

  tableWrapper: {
    border: "1px solid #e5e7eb",
    borderRadius: 12,
    overflow: "hidden",
    backgroundColor: "#fff",
  },

  toolbar: {
    padding: theme.spacing(2),
    backgroundColor: "#fafafa",
  },

  searchField: {
    backgroundColor: "#fff",
  },

  filterButton: {
    height: 56,
    minWidth: 120,
    fontWeight: 600,
  },

  tableContainer: {
    overflowX: "auto",
  },

  table: {
    minWidth: 900,
  },

  tableHead: {
    backgroundColor: "#f8fafc",
  },

  tableHeader: {
    fontWeight: 600,
    color: "#374151",
    whiteSpace: "nowrap",
  },

  tableRow: {
    "&:hover": {
      backgroundColor: "#f8fafc",
    },
  },

  emailLink: {
    color: "#386f50",
    fontWeight: 500,
    textDecoration: "none",

    "&:hover": {
      textDecoration: "underline",
    },
  },

  statusButton: {
    textTransform: "none",
    fontWeight: 600,
    minWidth: 115,
  },

  actionButton: {
    minWidth: 40,
    width: 40,
    height: 36,
    padding: 0,
  },

  pagination: {
    padding: theme.spacing(2),
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: theme.spacing(1),
    backgroundColor: "#fafafa",
  },

  pageButton: {
    minWidth: 40,
    width: 40,
    height: 40,
  },

  emptyState: {
    padding: theme.spacing(5),
    textAlign: "center",
    color: "#9ca3af",
  },

  dialogHeader: {
    backgroundColor: "#fafafa",
    borderBottom: "1px solid #e5e7eb",
  },

  dialogContent: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },

  dialogActions: {
    padding: theme.spacing(2),
    backgroundColor: "#fafafa",
    borderTop: "1px solid #e5e7eb",
  },

  dialogButton: {
    minWidth: 100,
    fontWeight: 600,
  },

  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}));

const StyledTableCell = withStyles(() => ({
  head: {
    backgroundColor: "#f8fafc",
    color: "#374151",
    fontWeight: 600,
    padding: "14px 16px",
    whiteSpace: "nowrap",
  },

  body: {
    fontSize: 14,
    padding: "14px 16px",
  },
}))(TableCell);

const StyledTableRow = withStyles(() => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: "#fcfcfd",
    },

    "&:hover": {
      backgroundColor: "#f8fafc",
    },
  },
}))(TableRow);

export default function View() {
  const classes = useStyles();
  const alert = useAlert();

  const [search, setSearch] = useState("");
  const [getUsers, setGetUsers] = useState([]);
  const [openActive, setOpenActive] = useState(false);
  const [user_ID, setuser_ID] = useState("");
  const [loading, setLoading] = useState(false);

  const [backdisable, setBackDisAble] = useState(true);
  const [nextdisable, setNextDisAble] = useState(false);

  const [limit, setLimit] = useState(10);
  const [start, setStart] = useState(0);

  const [value, setValue] = useState("");

  const [changepassword, setOpenChangePassword] = useState(false);
  const [valid, setValid] = useState("");

  const [UserName, setUsername] = useState("");
  const [UserNameID, setUsernameID] = useState(false);

  const [error, setError] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [password, setPassword] = useState("");

  // =========================
  // SEARCH
  // =========================
  const handleClickSearch = () => {
    return Users(search, start, limit);
  };

  // =========================
  // NEXT PAGE
  // =========================
  const handleNextPage = () => {
    setLimit(limit + 10);
    setStart(start + 10);
    setBackDisAble(false);

    return Users(
      search,
      start + 10,
      limit + 10
    );
  };

  // =========================
  // BACK PAGE
  // =========================
  const handleBackPage = () => {
    setLimit(limit - 10);
    setStart(start - 10);

    if (start === 10) {
      setNextDisAble(false);
      setBackDisAble(true);
    }

    return Users(
      search,
      start - 10,
      limit - 10
    );
  };

  // =========================
  // LOAD USERS
  // =========================
  const Users = useCallback(
    async (search, start, limit) => {
      setLoading(true);

      async function getAuction() {
        const results = await userList(
          search,
          start,
          limit
        );

        setLoading(false);

        if (results === "no record found") {
          setNextDisAble(true);
          setGetUsers([]);
        } else {
          setGetUsers(results.data);

          if (results.data.length < 10) {
            setNextDisAble(true);
          } else {
            setNextDisAble(false);
          }
        }
      }

      getAuction().catch((error) => {
        setLoading(false);
        console.error(error);
      });
    },
    []
  );

  useEffect(() => {
    Users();
  }, [Users]);

  // =========================
  // ACTIVE / INACTIVE
  // =========================
  const handleRadioChange = (event) => {
    setValue(event.target.value);
  };

  const handleClickActive = (e, id) => {
    setOpenActive(true);
    setuser_ID(id);
  };

  // =========================
  // CLOSE DIALOG
  // =========================
  const handleClose = () => {
    setOpenActive(false);
    setOpenChangePassword(false);
  };

  // =========================
  // UPDATE ACTIVE STATUS
  // =========================
  const handleFormActiveSubmit = (e) => {
    setLoading(true);

    e.preventDefault();

    let data = {
      isActive: value,
    };

    async function getActivation() {
      const results = await userActivation(
        user_ID,
        data
      );

      setLoading(false);
      setOpenActive(false);

      alert.success(results);
    }

    getActivation().catch((error) => {
      setLoading(false);
      console.error(error);
    });
  };

  // =========================
  // CHANGE PASSWORD
  // =========================
  const handleClickPassword = (e, id) => {
    setOpenChangePassword(true);

    let users = {};

    getUsers.map((row) => {
      if (row.id === id) {
        return (users = row);
      }

      return false;
    });

    setUsernameID(users.id);
    setUsername(users.email);
  };

  // =========================
  // PASSWORD INPUT
  // =========================
  const handleChangeEEE = (event) => {
    if (event.target.name === "password") {
      setPassword(event.target.value);
    } else if (
      event.target.name === "confirmPassword"
    ) {
      setConfirmPassword(event.target.value);
    }
  };

  // =========================
  // UPDATE PASSWORD
  // =========================
  const handleFormChangePassword = (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      setValid("Password and Confirm don't match");
      setError(true);
    } else {
      setLoading(true);
      setValid("");
      setError(false);
      setOpenChangePassword(false);

      let data = JSON.stringify({
        password: password,
      });

      let config = {
        method: "put",
        maxBodyLength: Infinity,
        url: `${Api.request.URL}/users/password/${UserNameID}`,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };

      api
        .request(config)
        .then((response) => {
          setLoading(false);
          setPassword("");
          setConfirmPassword("");
          alert.success(response.data.msg);
          console.log(
            JSON.stringify(response.data.msg)
          );
        })
        .catch((error) => {
          alert.error(error.response.data.errors);
          setLoading(false);
        });
    }
  };

  return (
    <Box className={classes.root}>
      <Paper className={classes.tableWrapper} elevation={1}>
        {/* =========================
            SEARCH TOOLBAR
        ========================= */}
        <Box className={classes.toolbar}>
          <Grid
            container
            spacing={2}
            alignItems="center"
          >
            <Grid item md={5} sm={7} xs={12}>
              <TextField
                fullWidth
                type="text"
                label="Search Users"
                name="search"
                value={search}
                onChange={(e) =>
                  setSearch(e.target.value)
                }
                placeholder="Search by name"
                variant="outlined"
                className={classes.searchField}
                InputProps={{
                  startAdornment: (
                    <SearchIcon
                      style={{
                        marginRight: 8,
                        color: "#9ca3af",
                      }}
                    />
                  ),
                }}
              />
            </Grid>

            <Grid item md={2} sm={3} xs={12}>
              <Button
                fullWidth
                color="primary"
                onClick={handleClickSearch}
                variant="contained"
                className={classes.filterButton}
                startIcon={<SearchIcon />}
              >
                Filter
              </Button>
            </Grid>
          </Grid>
        </Box>

        <Divider />

        {/* =========================
            TABLE
        ========================= */}
        <TableContainer className={classes.tableContainer}>
          <Table
            className={classes.table}
            aria-label="users table"
          >
            <TableHead className={classes.tableHead}>
              <TableRow>
                <StyledTableCell>
                  Email
                </StyledTableCell>

                <StyledTableCell>
                  Name
                </StyledTableCell>

                <StyledTableCell>
                  Phone #
                </StyledTableCell>

                <StyledTableCell>
                  User Type
                </StyledTableCell>

                <StyledTableCell>
                  Status
                </StyledTableCell>

                <StyledTableCell>
                  Date Created
                </StyledTableCell>

                <StyledTableCell align="center">
                  Action
                </StyledTableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {getUsers.length ? (
                getUsers.map((val, i) => {
                  let STATUS;

                  if (val.isActive === 1) {
                    STATUS = (
                      <Button
                        size="small"
                        className={
                          classes.statusButton
                        }
                        style={{
                          color: "#2e7d32",
                        }}
                        startIcon={
                          <DoneOutlineIcon />
                        }
                        onClick={(e) =>
                          handleClickActive(
                            e,
                            val.id
                          )
                        }
                      >
                        Active
                      </Button>
                    );
                  } else {
                    STATUS = (
                      <Button
                        size="small"
                        className={
                          classes.statusButton
                        }
                        style={{
                          color: "#d84315",
                        }}
                        startIcon={
                          <ErrorOutlineIcon />
                        }
                        onClick={(e) =>
                          handleClickActive(
                            e,
                            val.id
                          )
                        }
                      >
                        Inactive
                      </Button>
                    );
                  }

                  return (
                    <StyledTableRow key={i}>
                      <StyledTableCell>
                        <Link
                          className={
                            classes.emailLink
                          }
                          to={`/app/user/view/details/${val.firstname}/${val.lastname}/${val.id}`}
                        >
                          {val.email}
                        </Link>
                      </StyledTableCell>

                      <StyledTableCell>
                        {val.firstname +
                          " " +
                          val.lastname}
                      </StyledTableCell>

                      <StyledTableCell>
                        {val.phone}
                      </StyledTableCell>

                      <StyledTableCell>
                        {val.user_type}
                      </StyledTableCell>

                      <StyledTableCell>
                        {STATUS}
                      </StyledTableCell>

                      <StyledTableCell>
                        {val.created_date.slice(
                          0,
                          10
                        )}
                      </StyledTableCell>

                      <StyledTableCell align="center">
                        <Button
                          variant="contained"
                          color="primary"
                          size="small"
                          className={
                            classes.actionButton
                          }
                          title="Change Password"
                          startIcon={
                            <VpnKeyIcon />
                          }
                          onClick={(e) =>
                            handleClickPassword(
                              e,
                              val.id
                            )
                          }
                        >
                          {""}
                        </Button>
                      </StyledTableCell>
                    </StyledTableRow>
                  );
                })
              ) : (
                <StyledTableRow>
                  <StyledTableCell
                    colSpan={7}
                    className={
                      classes.emptyState
                    }
                  >
                    <Typography
                      variant="body2"
                    >
                      No Record Found
                    </Typography>
                  </StyledTableCell>
                </StyledTableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* =========================
            PAGINATION
        ========================= */}
        <Divider />

        <Box className={classes.pagination}>
          <Button
            className={classes.pageButton}
            disabled={backdisable}
            onClick={handleBackPage}
            title="Previous"
          >
            <ArrowBackIosIcon fontSize="small" />
          </Button>

          <Button
            className={classes.pageButton}
            disabled={nextdisable}
            onClick={handleNextPage}
            title="Next"
          >
            <ArrowForwardIosIcon fontSize="small" />
          </Button>
        </Box>

        {/* =========================
            ACTIVATE / DEACTIVATE
        ========================= */}
        <Dialog
          fullWidth
          maxWidth="xs"
          open={openActive}
          onClose={handleClose}
          aria-labelledby="activation-dialog-title"
        >
          <CardHeader
            className={classes.dialogHeader}
            avatar={<DoneOutlineIcon color="primary" />}
            title="Update User Status"
            subheader="Choose whether this user should be active."
          />

          <form onSubmit={handleFormActiveSubmit}>
            <DialogContent
              className={classes.dialogContent}
            >
              <RadioGroup
                name="quiz"
                value={value}
                onChange={handleRadioChange}
              >
                <FormControlLabel
                  value={"1"}
                  control={<Radio color="primary" />}
                  label="Activate User"
                />

                <FormControlLabel
                  value={"0"}
                  control={<Radio color="primary" />}
                  label="Deactivate User"
                />
              </RadioGroup>
            </DialogContent>

            <DialogActions
              className={classes.dialogActions}
            >
              <Button
                onClick={handleClose}
                variant="outlined"
                color="primary"
                className={classes.dialogButton}
              >
                Cancel
              </Button>

              <Button
                type="submit"
                variant="contained"
                color="primary"
                className={classes.dialogButton}
              >
                Submit
              </Button>
            </DialogActions>
          </form>
        </Dialog>

        {/* =========================
            CHANGE PASSWORD
        ========================= */}
        <Dialog
          fullWidth
          maxWidth="sm"
          open={changepassword}
          onClose={handleClose}
          aria-labelledby="password-dialog-title"
        >
          <CardHeader
            className={classes.dialogHeader}
            avatar={<LockIcon color="primary" />}
            title="Change Password"
            subheader="Set a new password for this user account."
          />

          <form onSubmit={handleFormChangePassword}>
            <DialogContent
              className={classes.dialogContent}
            >
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    label="Username"
                    value={UserName}
                    type="text"
                    InputProps={{
                      readOnly: true,
                    }}
                    fullWidth
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    label="Password"
                    type="password"
                    error={error}
                    helperText={valid}
                    onChange={handleChangeEEE}
                    name="password"
                    value={password}
                    fullWidth
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    name="confirmPassword"
                    label="Confirm Password"
                    onChange={handleChangeEEE}
                    value={confirmPassword}
                    type="password"
                    error={error}
                    fullWidth
                  />
                </Grid>
              </Grid>
            </DialogContent>

            <DialogActions
              className={classes.dialogActions}
            >
              <Button
                onClick={handleClose}
                variant="outlined"
                color="primary"
                className={classes.dialogButton}
              >
                Cancel
              </Button>

              <Button
                color="primary"
                variant="contained"
                type="submit"
                className={classes.dialogButton}
              >
                Update
              </Button>
            </DialogActions>
          </form>
        </Dialog>

        {/* =========================
            LOADING
        ========================= */}
        <Backdrop
          className={classes.backdrop}
          open={loading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </Paper>
    </Box>
  );
}